import { DEFAULT_PRODUCTS_CONFIG, IColorEntry, IProductsConfig } from '../../config/productsConfig';

export type IProductColor = IColorEntry;

let _config: IProductsConfig = DEFAULT_PRODUCTS_CONFIG;

export function setProductsConfig(cfg: IProductsConfig): void {
  _config = cfg;
}

export function getProductsConfig(): IProductsConfig {
  return _config;
}

export function getContentColor(contenu: string): IProductColor {
  if (!contenu) return _config.default;

  const upper = contenu.toUpperCase().trim();

  if (contenu.indexOf('/') >= 0) {
    const parts = contenu.split('/');
    const hasIntervention = parts.some(p =>
      ['VND', 'OD', 'TVX'].indexOf(p.trim().toUpperCase()) >= 0
    );
    if (hasIntervention) return _config.transition;
  }

  if (_config.products[contenu]) return _config.products[contenu];
  if (_config.products[upper]) return _config.products[upper];
  if (_config.interventions[contenu]) return _config.interventions[contenu];
  if (_config.interventions[upper]) return _config.interventions[upper];

  for (const key of Object.keys(_config.products)) {
    if (upper.indexOf(key.toUpperCase()) >= 0) return _config.products[key];
  }

  return _config.default;
}

export function isIntervention(contenu: string): boolean {
  if (!contenu) return false;
  const upper = contenu.toUpperCase().trim();
  return ['VND', 'OD', 'TVX', 'EPREUVE'].indexOf(upper) >= 0 ||
    upper.indexOf('VND') >= 0 || upper.indexOf('OD') >= 0 || upper === 'TVX';
}

export function getAllProducts(): string[] {
  return Object.keys(_config.products);
}

export function getAllInterventions(): string[] {
  return Object.keys(_config.interventions);
}
